module.exports = __webpack_public_path__ + "static/img/banner-edu.5e880cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-edu.jpg
// module id = 1+FA
// module chunks = 1